export interface PlanPrice {
  id: string;
  name: string;
  currency: string;
  amount: number;
}

export interface Plan {
  id: number;
  label: string;
  type: "support" | "education" | "company";
  // Null when the price id is not bound in DB or unknown to the Stripe account
  stripeAnnualPrice: PlanPrice | null;
  stripeMonthlyPrice: PlanPrice | null;
}

export const getPlanLabelKey = (planType: Plan["type"]) =>
  planType === "education" ? "support" : planType;

export type RecurringInterval = "monthly" | "annual";

export interface Subscription {
  id: number;
  planId: number;
  plan: Plan;
  startDate: string;
  endDate: string;
  recurringInterval: RecurringInterval;
  stripeSubscriptionId: string | null;
  stripeSubscription: {
    cancelAt: Date | null;
    status:
      | "incomplete"
      | "incomplete_expired"
      | "trialing"
      | "active"
      | "past_due"
      | "canceled"
      | "unpaid"
      | "paused";
  } | null;
}
